"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const React = __importStar(require("react"));
const icons_1 = require("src/components/common/icons");
const FreePlanModal = ({ isOpen, onClose, onConfirm, onChooseFreePlan }) => {
    const limitationItems = [
        'No player availability',
        'No team training, lineups, or statistics',
        'No ad-free experience',
        'Limited storage for photos & videos',
        'Limited rosters size',
    ];
    return (React.createElement(snap_ui_1.ModalContainer, { isOpen: isOpen, onClose: onClose, closeButton: false, "data-testid": "free-plan-modal" },
        React.createElement("div", { className: "sui-flex-grow" },
            React.createElement("h2", { className: "sui-heading-md sui-mb-3" }, "By choosing free, you won\u2019t have access to some features."),
            React.createElement("ul", { className: "sui-mb-3" }, limitationItems.map((item, index) => (React.createElement("li", { key: index, className: "sui-flex sui-items-center sui-mb-2 sui-gap-1" },
                React.createElement(icons_1.CloseRound, { width: 16, height: 16 }),
                React.createElement("span", { className: "sui-body-dense" }, item)))))),
        React.createElement("div", null,
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "unlock-premium-plan-button", className: "sui-mb-2 sui-w-full", variantType: "primary", labelText: "Unlock with the Premium plan", onClick: onConfirm }),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "continue-free-plan-button", className: "sui-w-full", variantType: "secondary", labelText: "Continue with free", onClick: onChooseFreePlan }))));
};
exports.default = FreePlanModal;
